var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartSuitFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0084 5.16227C18.1675 5.67067 15.9969 9.06675 15.9969 9.06675C15.9969 9.06675 13.8162 5.67067 10.9854 5.16227C3.97328 3.91162 1.08242 10.1547 2.25277 14.8015C3.98329 21.6648 12.3058 27.8164 15.0866 29.7178C15.6367 30.0941 16.357 30.0941 16.9171 29.7178C19.708 27.8164 28.0304 21.6648 29.7509 14.8015C30.9113 10.1547 28.0204 3.91162 21.0084 5.16227Z",
    fill: "#F8312F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSuitFlat);
export default __webpack_public_path__ + "static/media/heart_suit_flat.708a22781f7b5879aa55637c92da8489.svg";
export { ForwardRef as ReactComponent };